import {MdArrowBack} from 'react-icons/md'
import useWebsiteInfo from '@hooks/useWebsiteInfo'
import ReservationsCheckoutCard from '@page-components/Reservations/Card'
import Link from 'next/link'

import ReservePartySize from './PartySize'
import SelectDay from './SelectDay'
import SelectHours from './SelectHours'
import SelectSlot from './SelectSlot'

export default function SelectDate() {
  const website = useWebsiteInfo()
  return (
    <ReservationsCheckoutCard>
      <Link href={`/reservas`} passHref className="flex items-center text-sm space-x-1">

        <MdArrowBack />
        <span>Volver</span>

      </Link>
      <div className="mb-5">
        <h1>Reserva una mesa en {website.websiteName}</h1>
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-1 lg:grid-cols-3 space-x-2 sm:space-x-0 lg:space-x-2">
        <SelectDay />
        <SelectHours />
        <ReservePartySize />
      </div>
      <SelectSlot />
    </ReservationsCheckoutCard>
  );
}
